/** @jsx jsx */
import React from "react"
import { jsx, useColorMode, Link as TLink } from "theme-ui"
import useMinimalBlogConfig from "../hooks/use-minimal-blog-config"
import ColorModeToggle from "./colormode-toggle"


const HeaderExternalLinks = () => {
  const { externalLinks } = useMinimalBlogConfig()
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`
  const toggleColorMode = (e: any) => {
    e.preventDefault()
    setColorMode(isDark ? `light` : `dark`)
  }

  return (
    <React.Fragment>
      {externalLinks && externalLinks.length > 0 && (
        <div sx={{ "a:not(:first-of-type)": { ml: 3 }, fontSize: [1, `18px`], margin: `5px 0px 5px 10px` }}>

            <TLink key="https://github.com/barrelmaker" href="https://github.com/barrelmaker" target="_blank">
              {/* <img alt='Logo' style={{ width: 40 }} src={linkedinlogo}/> */}
              <img alt='Github Logo'
                   style={{ width: `clamp(20px, 4vw, 40px)` }}
                   src={require(!isDark ? "../../../../../static/github-logo.png" : "../../../../../static/github-logo-light.png")}
              />
            </TLink>

            <TLink key="https://www.linkedin.com/in/cooper-leong/" href="https://www.linkedin.com/in/cooper-leong/" target="_blank">
              {/* <img alt='Logo' style={{ width: 40 }} src={linkedinlogo}/> */}
              <img alt='Logo' 
                   style={{ width: `clamp(20px, 4vw, 40px)` }}
                   src={require(!isDark ? "../../../../../static/linkedin-logo.png" : "../../../../../static/linkedin-logo-light.png")}
              />
            </TLink>

            <TLink key="mailto:cooperleong0@gmail.com" href="mailto:cooperleong0@gmail.com" target="_blank">
              {/* <img alt='Logo' style={{ width: 40 }} src={linkedinlogo}/> */}
              <img alt='Logo'
                   style={{ width: `clamp(20px, 4vw, 40px)` }}
                   src={require(!isDark ? "../../../../../static/gmail-logo.png" : "../../../../../static/gmail-logo-light.png")}
              />
            </TLink>
            
        </div>
      )}
    </React.Fragment>
  )
}

export default HeaderExternalLinks
